export default __webpack_public_path__ + "static/pixea-example4-a7b0d7666b212ba4759766fa55c41b75.png";